/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetUnproxiedMcpServerUsageRequestBody,
  GetUnproxiedMcpServerUsageRequestBody$Outbound,
  GetUnproxiedMcpServerUsageRequestBody$outboundSchema,
} from "../components/getunproxiedmcpserverusagerequestbody.js";

export type GetUnproxiedMcpServerUsageSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetUnproxiedMcpServerUsageSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetUnproxiedMcpServerUsageSecurity = {
  option1?: GetUnproxiedMcpServerUsageSecurityOption1 | undefined;
  option2?: GetUnproxiedMcpServerUsageSecurityOption2 | undefined;
};

export type GetUnproxiedMcpServerUsageRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  getUnproxiedMcpServerUsageRequestBody: GetUnproxiedMcpServerUsageRequestBody;
};

/** @internal */
export type GetUnproxiedMcpServerUsageSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetUnproxiedMcpServerUsageSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetUnproxiedMcpServerUsageSecurityOption1$Outbound,
    GetUnproxiedMcpServerUsageSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getUnproxiedMcpServerUsageSecurityOption1ToJSON(
  getUnproxiedMcpServerUsageSecurityOption1:
    GetUnproxiedMcpServerUsageSecurityOption1,
): string {
  return JSON.stringify(
    GetUnproxiedMcpServerUsageSecurityOption1$outboundSchema.parse(
      getUnproxiedMcpServerUsageSecurityOption1,
    ),
  );
}

/** @internal */
export type GetUnproxiedMcpServerUsageSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetUnproxiedMcpServerUsageSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetUnproxiedMcpServerUsageSecurityOption2$Outbound,
    GetUnproxiedMcpServerUsageSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getUnproxiedMcpServerUsageSecurityOption2ToJSON(
  getUnproxiedMcpServerUsageSecurityOption2:
    GetUnproxiedMcpServerUsageSecurityOption2,
): string {
  return JSON.stringify(
    GetUnproxiedMcpServerUsageSecurityOption2$outboundSchema.parse(
      getUnproxiedMcpServerUsageSecurityOption2,
    ),
  );
}

/** @internal */
export type GetUnproxiedMcpServerUsageSecurity$Outbound = {
  Option1?: GetUnproxiedMcpServerUsageSecurityOption1$Outbound | undefined;
  Option2?: GetUnproxiedMcpServerUsageSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetUnproxiedMcpServerUsageSecurity$outboundSchema: z.ZodMiniType<
  GetUnproxiedMcpServerUsageSecurity$Outbound,
  GetUnproxiedMcpServerUsageSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetUnproxiedMcpServerUsageSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetUnproxiedMcpServerUsageSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getUnproxiedMcpServerUsageSecurityToJSON(
  getUnproxiedMcpServerUsageSecurity: GetUnproxiedMcpServerUsageSecurity,
): string {
  return JSON.stringify(
    GetUnproxiedMcpServerUsageSecurity$outboundSchema.parse(
      getUnproxiedMcpServerUsageSecurity,
    ),
  );
}

/** @internal */
export type GetUnproxiedMcpServerUsageRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  GetUnproxiedMcpServerUsageRequestBody:
    GetUnproxiedMcpServerUsageRequestBody$Outbound;
};

/** @internal */
export const GetUnproxiedMcpServerUsageRequest$outboundSchema: z.ZodMiniType<
  GetUnproxiedMcpServerUsageRequest$Outbound,
  GetUnproxiedMcpServerUsageRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    getUnproxiedMcpServerUsageRequestBody:
      GetUnproxiedMcpServerUsageRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      getUnproxiedMcpServerUsageRequestBody:
        "GetUnproxiedMcpServerUsageRequestBody",
    });
  }),
);

export function getUnproxiedMcpServerUsageRequestToJSON(
  getUnproxiedMcpServerUsageRequest: GetUnproxiedMcpServerUsageRequest,
): string {
  return JSON.stringify(
    GetUnproxiedMcpServerUsageRequest$outboundSchema.parse(
      getUnproxiedMcpServerUsageRequest,
    ),
  );
}
